import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import {
  HEADER_HEIGHT,
  MIN_SCREEN_WIDTH,
} from '@/components/templates/ScreenWrapper.tsx'
import { Header, Header4 } from '@/components/Text.tsx'

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.common.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  height: 100svh;

  max-height: 100vh;
  min-width: ${MIN_SCREEN_WIDTH}px;
  max-width: 100%;
`

const ScreenContent = styled.div`
  flex-wrap: wrap;
  position: relative;
  padding: 32px 64px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`

const NavText = styled(Header4)`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.common.black95};
`

const HeaderBar = styled.div`
  background: ${({ theme }) => theme.colors.common.white};
  box-shadow: ${({ theme }) =>
    `0px 1.4px 14px 0px ${theme.colors.common.black05}`};
  padding: 24px 16px;
  align-items: flex-end;
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  flex: 0 0 ${HEADER_HEIGHT}px;
`

export const Maintenance = () => {
  const { t } = useTranslation('translation')

  return (
    <Wrapper>
      <HeaderBar>
        <NavText>{t('navHeader')}</NavText>
      </HeaderBar>
      <ScreenContent>
        <Header>{t('maintenance.title')}</Header>
        <Header4>{t('maintenance.subtitle')}</Header4>
      </ScreenContent>
    </Wrapper>
  )
}
